"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvisorEmbeddedCTAPlacement = exports.FreeCoffeeUpsellFlowStatus = exports.AVEN_ADVISOR_UTM_SOURCE = void 0;
exports.AVEN_ADVISOR_UTM_SOURCE = 'advisor';
var FreeCoffeeUpsellFlowStatus;
(function (FreeCoffeeUpsellFlowStatus) {
    FreeCoffeeUpsellFlowStatus["PRE_REDEEM"] = "PRE_REDEEM";
    FreeCoffeeUpsellFlowStatus["INTERSTITIAL"] = "INTERSTITIAL";
    FreeCoffeeUpsellFlowStatus["PRE_CLAIM_POST_INTERSTITIAL"] = "PRE_CLAIM_POST_INTERSTITIAL";
    FreeCoffeeUpsellFlowStatus["POST_REDEEM"] = "POST_REDEEM";
})(FreeCoffeeUpsellFlowStatus || (exports.FreeCoffeeUpsellFlowStatus = FreeCoffeeUpsellFlowStatus = {}));
var AdvisorEmbeddedCTAPlacement;
(function (AdvisorEmbeddedCTAPlacement) {
    AdvisorEmbeddedCTAPlacement["starbucksCard"] = "starbucksCard";
})(AdvisorEmbeddedCTAPlacement || (exports.AdvisorEmbeddedCTAPlacement = AdvisorEmbeddedCTAPlacement = {}));
